import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatInput} from '@angular/material/input';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {ReservedAppointmentModel} from '../../models/appointment/appointment.model';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-application-cancel-dialog',
    imports: [
        MatInput,
        ReactiveFormsModule,
        DatePipe
    ],
  templateUrl: './application-cancel-dialog.component.html',
  styleUrl: './application-cancel-dialog.component.sass'
})
export class ApplicationCancelDialogComponent {
    appointmentCancelInfo = new FormControl('', Validators.required);
    appointment!: ReservedAppointmentModel
    showInfoText: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<ApplicationCancelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if (data) {
            if (data.appointment) {
                this.appointment = data.appointment;

            }
            if (data.isPatient) {
                this.showInfoText = true;
            }
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        this.dialogRef.close({isCancel: true, reason: this.appointmentCancelInfo.value});
    }

}
